import { IAutocompleteBaseOption } from '../types'
import { createAddOption } from './createOption'

type TPickedProps =
  | 'groupIndex'
  | 'groupName'
  | 'iconName'
  | 'optionType'
  | 'dividerAfter'
  | 'dividerBefore'

export interface IGetAutocompleteActionConfig extends Pick<IAutocompleteBaseOption, TPickedProps> {
  /**
   * Input value that is used to render custom options
   */
  inputValue?: string
  /**
   * Dynamically set label based on other props
   * @example (val: string) => `Add ${val}`
   */
  getLabel?: (inputValue: string) => string
  /**
   * Dynamically create action based on other props
   * @exmple val => () => alert(`you clicked ${val}`)
   */
  onClick?: (inputValue: string) => void
}

/**
 * Compose options array for <Autocomplete />
 * @example
 *  const customerOptions = getAutocompleteAction({
 *    groupIndex: 1,
 *    optionType: 'withIcon',
 *    iconName: 'PlusIcon',
 *    onClick: () => alert('clicked')
 *  })
 */
export function getAutocompleteAction(
  config: IGetAutocompleteActionConfig
): IAutocompleteBaseOption[] {
  const {
    groupIndex,
    iconName,
    inputValue = '',
    optionType = 'default',
    getLabel: getLabelProp = (val: string) => val,
    onClick: onClickProp = () => {},
    ...props
  } = config || {}
  const text = getLabelProp(inputValue)
  const onClick = () => onClickProp(inputValue)
  return [
    createAddOption({
      groupIndex,
      iconName,
      text,
      inputValue,
      optionType,
      onClick,
      ...props,
    }),
  ]
}

export default getAutocompleteAction
